<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>

  <!-- Form -->
  <form @submit.prevent="store" class="form-content">
    <div class="form-content-inner">
      <control
        type="hidden"
        v-model="employeetraining.id"
        :hasError="!!errors.id"
        id="id"
      />

      <div class="form-col">
        <field
          :label="$t('employeetraining.employee_name')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.employee_id"
        >
          <control
            :options="employeeOptions"
            :placeholder="$t('employeetraining.employee_name')"
            v-model="employeetraining.employee_id"
            id="employee_id"
            :hasError="!!errors.employee_id"
            required
            :disabled="isEmployee"
          />
        </field>
      </div>
      <div class="form-col">
       <field
          :label="$t('employeetraining.name')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.name"
        >
          <control
            type="text"
            :placeholder="$t('employeetraining.name')"
            v-model="employeetraining.name"
            :hasError="!!errors.name"
            id="name"
          />
        </field>
      </div>
      <div class="form-col">
        <field
          :label="$t('employeetraining.organizer')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.organizer"
        >
          <control
            type="text"
            :placeholder="$t('employeetraining.organizer')"
            v-model="employeetraining.organizer"
            :hasError="!!errors.organizer"
            id="organizer"
          />
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('employeetraining.venue')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.venue"
        >
          <control
            type="text"
            :placeholder="$t('employeetraining.venue')"
            v-model="employeetraining.venue"
            :hasError="!!errors.venue"
            id="venue"
          />
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('employeetraining.start_date')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.start_date"
        >
          <control
            type="date"
            v-model="employeetraining.start_date"
            :hasError="!!errors.start_date"
            id="start_date"
          />
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('employeetraining.end_date')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.end_date"
        >
          <control
            type="date"
            v-model="employeetraining.end_date"
            :hasError="!!errors.end_date"
            id="end_date"
          />
        </field>
      </div>

      <div class="form-col">
        <!-- <field :label="$t('employeetraining.is_external')" class="w-full md:mr-2 mb-2 md:mb-0"
                    :hasError="errors.is_external">
                    <control type="switch" v-model="employeetraining.is_external"
                        :hasError="!!errors.is_external" id="is_external"
                        :options="{ true: 'Yes', false: 'No' }" />
                </field> -->

        <field
          :label="'External Training?'"
          class="w-full md:ml-2 mb-2 md:mb-0"
        >
          <check-radio-picker
            type="radio"
            name="is_external"
            v-model="employeetraining.is_external"
            :hasError="!!errors.is_external"
            :options="{ true: 'Yes', false: 'No' }"
            style="display: flex; flex-wrap: nowrap; gap: 1.25rem"
          >
          </check-radio-picker>
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('employeetraining.certificate_no')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.certificate_no"
        >
          <control
            type="text"
            :placeholder="$t('employeetraining.certificate_no')"
            v-model="employeetraining.certificate_no"
            :hasError="!!errors.certificate_no"
            id="certificate_no"
          />
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('employeetraining.certificate_exp_date')"
          class="w-full md:mr-2 mb-2 md:mb-0"
          :hasError="errors.certificate_exp_date"
        >
          <control
            type="date"
            v-model="employeetraining.certificate_exp_date"
            :hasError="!!errors.certificate_exp_date"
            id="certificate_exp_date"
          />
        </field>
      </div>

      <div
        class="buttons-submit transition-colors duration-1000"
        :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'"
      >
        <jb-buttons class="buttons-action-submit">
          <jb-button
            type="submit"
            color="info"
            :icon="mdiCheckBold"
            :label="$t('finance.button.btnSubmit')"
            class="form-submit-btn"
          />
          <jb-button
            type="button"
            color="info"
            outline
            :label="$t('finance.button.btnReset')"
            class="form-noicon-btn btn-reset"
            @click="reset()"
          />
        </jb-buttons>
      </div>
    </div>
  </form>
</template>

<script>
/* eslint-disable */
import {
  ref,
  reactive,
  onMounted,
  onBeforeMount,
  watch,
  watchEffect,
} from "vue";
import axios from "axios";
import { mdiBallot, mdiCheckBold } from "@mdi/js";
import Control from "@/components/Control";
import JbButton from "@/components/JbButton";
import JbButtons from "@/components/JbButtons";
import Field from "@/components/Field";
import CheckRadioPicker from "@/components/CheckRadioPicker";
import { useToast } from "vue-toastification";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "EmployeeTrainingForm",
  components: {
    Field,
    Control,
    Loading,
    JbButton,
    JbButtons,
    CheckRadioPicker,
  },
  props: {
    showEdit: { type: Boolean, default: false },
    propEmployeeTraining: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propObject: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propClass: {
      type: Object,
      default: () => ({ empty: true }),
    },
  },
  emits: ["close-modal", "submit", "reset-modal"],
  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Forms"]);
    const isLoading = ref(false);
    const toast = useToast();
    const router = useRouter();
    const errors = ref({});
    const employeeOptions = ref([]);
    const str = useStore();
    const userlogin = localStorage.getItem("name");
    const employeeList = ref();
    const employeetraining = reactive({
      id: "",
      employee_id: "",
      name: "",
      organizer: "",
      venue: "",
      start_date: "",
      end_date: "",
      is_external: false,
      certificate_no: "",
      certificate_exp_date: "",
      created_by: "",
      updated_by: "",
    });

    const isEmployee = ref(false);

    const getEmployee = async () => {
      try {
        isLoading.value = true;
        const userId = localStorage.getItem('user_id')
        const branchId = localStorage.getItem('branch_id')
        const params = {
          user_id: userId,
          branch_id: branchId
        }

        if (!userId) {
          toast.error("User ID not found in local storage.");
          isLoading.value = false;
          return;
        }

        const response = await axios.get("employee", {
          params: { user_id: userId, branch_id: branchId },
          headers: { "Content-Encoding": "gzip" },
        });

        if (response.data.success && Array.isArray(response.data.data)) {
          employeeOptions.value = response.data.data;

          const matchedEmployee = employeeOptions.value.find(
            (item) => item.user_id === userId
          );

          if (matchedEmployee) {
            employeetraining.employee_id = matchedEmployee.id;
            isEmployee.value = true;
          }
        } else {
          toast.error("Failed to fetch employee data.");
        }
      } catch (error) {
        toast.error(
          error.response?.data?.message ||
            "Failed to load employee training data"
        );
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };

    const fetchExistingData = async () => {
      if (
        props.showEdit &&
        props.propEmployeeTraining &&
        props.propEmployeeTraining.id
      ) {
        try {
          isLoading.value = true;
          const response = await axios.get(
            `/employee-training/${props.propEmployeeTraining.id}`
          );
          if (response.data.success && response.data.data) {
            // Pastikan data dari server diassign ke progexctime
            const existingData = response.data.data;
            Object.assign(employeetraining, {
              id: existingData.id || "",
              employee_id: existingData.employee_id || "",
              name: existingData.name || "",
              organizer: existingData.organizer || "",
              venue: existingData.venue || "",
              start_date: existingData.start_date || "",
              end_date: existingData.end_date || "",
              is_external: existingData.is_external || false,
              certificate_no: existingData.certificate_no || "",
              certificate_exp_date: existingData.certificate_exp_date || "",
              created_by: existingData.created_by || "",
              updated_by: existingData.updated_by || "",
            });
            console.log("Data existing diambil:", employeetraining);
          }
          isLoading.value = false;
        } catch (error) {
          toast.error("Failed to load existing data");
          console.log("Error fetching existing data:", error);
          isLoading.value = false;
        }
      }
    };

    const store = async () => {
      isLoading.value = true;
      const url = props.showEdit
        ? "/employee-training/" + employeetraining.id
        : "/employee-training";
      const method = props.showEdit ? "PUT" : "POST";

      if (method === "POST") {
        employeetraining.created_by = userlogin;
      } else {
        employeetraining.updated_by = userlogin;
      }

      // employeetraining.is_external = customElementsForm.is_external

      console.log(
        "Data yang akan dikirim:",
        JSON.stringify(employeetraining, null, 2)
      );

      await axios({
        method,
        url,
        data: employeetraining,
      })
        .then((response) => {
          if (response.data.success) {
            emit("reset-modal");
            emit("close-modal");
            toast.success(response.data.message);
          } else {
            errors.value = response.data.messages || response.data.errors;
            toast.error(response.data.messages || "Failed to save data");
          }
          isLoading.value = false;
          if (!props.showEdit) reset(); // Reset hanya untuk create
        })
        .catch((error) => {
          if (error.response) {
            errors.value = error.response.data.errors || {};
            toast.error(error.response.data.message || "Error occurred");
            console.log("Error response:", JSON.stringify(error.response.data));
          } else if (error.message) {
            toast.error(error.message);
            console.log("Error message:", JSON.stringify(error.message));
          }
          isLoading.value = false;
        });
    };

    const reset = () => {
      Object.assign(employeetraining, {
        id: "",
        employee_id: "",
        name: "",
        organizer: "",
        venue: "",
        start_date: "",
        end_date: "",
        is_external: false,
        certificate_no: "",
        certificate_exp_date: "",
        created_by: "",
        updated_by: "",
      });
      errors.value = {};
    };

    onBeforeMount(() => {
      // Jika ada data dari prop saat sebelum mount, gunakan itu
      if (
        props.showEdit &&
        props.propEmployeeTraining &&
        !props.propEmployeeTraining.empty
      ) {
        Object.assign(employeetraining, props.propEmployeeTraining);
        console.log("Data dari prop diinisialisasi:", employeetraining);
      }
    });

    onMounted(() => {
      getEmployee();
      if (props.showEdit) {
        fetchExistingData(); // Ambil data dari server jika dalam mode edit
      }
    });

    watch(
      () => props.propEmployeeTraining,
      (newVal, oldVal) => {}
    );

    watchEffect(() => {
      const newobject = props.propObject;
      Object.assign(employeetraining, newobject);

      if (!props.showEdit) {
        employeetraining.id = null;
        employeetraining.employee_id = null;
        employeetraining.name = null;
        employeetraining.organizer = null;
        employeetraining.venue = null;
        employeetraining.start_date = null;
        employeetraining.end_date = null;
        employeetraining.is_external = false;
        employeetraining.certificate_no = null;
        employeetraining.certificate_exp_date = null;
        employeetraining.created_by = null;
        employeetraining.updated_by = null;
      }

      const newemployeetraining = props.propClass;
      employeetraining.submenu = newemployeetraining.submenu;
      employeetraining.ein = newemployeetraining.ein;
      employeetraining.employee_id = newemployeetraining.employee_id;
      employeetraining.nickname = newemployeetraining.nickname;
    });

    return {
      isLoading,
      titleStack,
      employeetraining,
      errors,
      mdiBallot,
      mdiCheckBold,
      employeeOptions,
      store,
      reset,
      router,
      toast,
      userlogin,
      str,
      isEmployee,
    };
  },
  methods: {
    clearForm() {
      Object.assign(this.employeetraining, {
        id: "",
        employee_id: "",
        name: "",
        organizer: "",
        venue: "",
        start_date: "",
        end_date: "",
        is_external: false,
        certificate_no: "",
        certificate_exp_date: "",
        created_by: "",
        updated_by: "",
      });
    },
    onChange(employeetraining, event) {
      if (event.target.value) {
        employeetraining.employee_id = event.target.value;
      }
    },
  },
};
</script>
